var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"id":"filter-input","type":"search","debounce":"500","placeholder":_vm.getSearchPlaceHolder},on:{"update":function($event){return _vm.$emit('filter-change', _vm.filter)}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }